import { createSlice } from '@reduxjs/toolkit';

/**
 *
 * @type StateStoreState
 */
const initialState = {
  stateList: { loading: false, data: null, error: null }
};

export const StateSlice = createSlice({
  name: 'state',
  initialState,
  reducers: {
    fetchStateListRequest: (state, action) => {
      state.stateList.loading = true;
      state.stateList.error = null;
    },
    fetchStateListSuccess: (state, action) => {
      state.stateList.data = action.payload;
      state.stateList.loading = false;
      state.stateList.error = null;
    },
    fetchStateListFailure: (state, action) => {
      state.stateList.data = null;
      state.stateList.loading = false;
      state.stateList.error = action.payload;
    }
  }
});

export const {
  fetchStateListRequest,
  fetchStateListSuccess,
  fetchStateListFailure
} = StateSlice.actions;

/**
 *
 * @param {*} store
 * @returns {StateStoreState['stateList']}
 */
export const getStateListState = (store) => store.state?.stateList;

export default StateSlice.reducer;
